import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IHeaderItem, IContractLot, IResponse } from 'src/app/models/generic';
import { ApiManualBatchService } from './../../../../services/api/api-manual-batch.service';
import { IFieldOrder } from 'src/app/models/manual-batch';
import { ManualBatchContractsHeaderItems } from 'src/app/shared/utils/base';
import { NotificationService } from '../../../../shared/components/notification/notification.service';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SnackbarType } from '../../../../models/snackbar-type.enum';

@Component({
  selector: 'app-ordered-contract-list',
  templateUrl: './ordered-contract-list.component.html',
  styleUrls: ['./ordered-contract-list.component.scss']
})
export class OrderedContractListComponent implements OnInit {
  private _contracts: IContractLot[] = [];

  @Input()
  set contracts(val: IContractLot[]) {
    this._contracts = val;

    if (this._contracts.length === 0 && this.checkAll) {
      this.checkAll = false;
      this._manualBatchService.resetContracts();
    }
  }

  get contracts() {
    return this._contracts;
  }

  @Output() orderChangeEvent = new EventEmitter<IFieldOrder[]>();

  headerItems: IHeaderItem[] = [];
  checkAll: boolean = false;

  constructor(
    private _manualBatchService: ApiManualBatchService,
    private _notificationService: NotificationService,
    private _snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.getHeaderItems();
  }

  getHeaderItems(): void {
    const header = JSON.stringify(ManualBatchContractsHeaderItems);
    this.headerItems = JSON.parse(header);
  }

  orderChange(fieldsOrder: any): void {
    this.orderChangeEvent.emit(fieldsOrder);
  }

  changeHeaderCheckbox(event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (this.contracts.length === 0) {
      checkbox.checked = false;
      return;
    }

    const isChecked = checkbox.checked;
    if (isChecked) {
      this._manualBatchService.validateContracts(this.contracts)
        .subscribe({
          next: (response: IResponse) => {
            if (response.success) {
              this.headerCheckboxSelection();
              return;
            }

            const contractsIds = response.data || [];
            this.showErrorNotification(response.message);
            checkbox.checked = this.contracts.length === contractsIds.length;
            this.checkValidContracts(contractsIds);
          },
          error: (error) => console.error(error)
        });
    }
    else {
      this.headerCheckboxSelection();
    }
  }

  changeCardCheckbox(event: Event, contract: IContractLot): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    if (isChecked) {
      this._manualBatchService.validateContracts([contract])
        .subscribe({
          next: (response: IResponse) => {
            if (response.success) {
              this.cardCheckboxSelection(contract);
              return;
            }

            this.showErrorNotification(response.message);
            checkbox.checked = false;
          },
          error: (error) => console.error(error)
        });
    }
    else {
      this.cardCheckboxSelection(contract);
    }
  }

  checkContract(contractId: string): boolean {
    return this._manualBatchService.checkUncheckContract(
      contractId,
      this.checkAll
    );
  }

  get isHeaderIndeterminate(): boolean {
    if (this.contracts.length === 0) {
      return false;
    }

    const selectedCount = this.contracts.filter((contract) =>
      this.checkContract(contract.ContractId)
    ).length;

    return selectedCount > 0 && selectedCount < this.contracts.length;
  }

  headerCheckboxSelection(): void {
    this.checkAll = !this.checkAll;

    if (this.checkAll) {
      this._manualBatchService.changeAllSelectedContracts();
    } else {
      this._manualBatchService.resetContracts();
    }
  }

  cardCheckboxSelection(contract: IContractLot): void {
    if (this.checkAll) {
      this._manualBatchService.changeExceptionsContracts(contract);
    } else {
      this._manualBatchService.changeSelectedContracts(contract);
    }
  }

  showErrorNotification(message: string): void {
    this._snackbarService.openSnackBarWithCloseButton(message, SnackbarType.Danger, 10000,
      () => {
        console.log('O Snackbar foi fechado!');
      });
    return;

    // Foi definido junto ao cliente que não será usado o estilo do CredIntegrado.
    this._notificationService.showNotification({
      id: this._notificationService.generateUniqueId(),
      message: message,
      type: 'error',
      iconUrl: '../../../../../assets/imgs/error-icon.png',
      isVisible: true,
      hasIcon: true,
      closeButton: true,
      autoClose: true,
      autoCloseDuration: 5000,
    });
  }

  checkValidContracts(contractsIds: string[]): void {
    contractsIds.forEach((contractId) => {
      const contract = this.contracts.find((c) => c.ContractId === contractId);
      if (contract) {
        const checkboxElement = document.getElementById(contractId) as HTMLInputElement;
        if (checkboxElement && !checkboxElement.checked) {
          const mockEvent = new Event('change', { bubbles: true, cancelable: true });
          Object.defineProperty(mockEvent, 'target', { value: checkboxElement });
          this.changeCardCheckbox(mockEvent, contract);
        }
      }
    });
  }
}
